import React from 'react';
import {
  IndustriesSection,
  IndustryGrid,
  IndustryItem,
  IndustriesIntro,
} from './Industries.styles';
import { SectionHeader } from '../About.styles';

const Industries = () => {
  return (
    <IndustriesSection>
      <SectionHeader>
        {/* <p className="eyebrowHeader">Industries We Support</p> */}
        <h3>
          Safety programs and workplace support tailored to a wide range of
          industries.
        </h3>
      </SectionHeader>

      <IndustriesIntro>
        We have developed Occupational Health & Safety programs, training, and
        compliance support for businesses across many industries throughout
        Atlantic Canada.
      </IndustriesIntro>

      <IndustryGrid>
        <IndustryItem>Construction</IndustryItem>
        <IndustryItem>Marine</IndustryItem>
        <IndustryItem>Road Building</IndustryItem>
        <IndustryItem>Hotels & Hospitality</IndustryItem>
        <IndustryItem>Ski Resorts</IndustryItem>
        <IndustryItem>Welding & Fabrication</IndustryItem>
        <IndustryItem>Child Care</IndustryItem>
        <IndustryItem>Farms & Agriculture</IndustryItem>
        <IndustryItem>Trucking</IndustryItem>
        <IndustryItem>Forestry</IndustryItem>
      </IndustryGrid>
    </IndustriesSection>
  );
};

export default Industries;
